/**
 * No-effect placeholder function.
 */
export const NO_OP = () => { };
